import React, { useContext, useEffect, useState } from 'react'
import './Detail.css'
import 'react-tabs/style/react-tabs.css';
import { Button, Col, Container, Row } from 'react-bootstrap'
import { Tab, TabList, TabPanel, Tabs } from "react-tabs"
import { Link, useParams } from 'react-router-dom';
import { CartContext } from '../Context/CartContext';

const detailUrl = `https://zomatourl.herokuapp.com/details`
const menuUrl = `https://zomatourl.herokuapp.com/menu`

const DetailDisplay = () => {
    const { cart, setCart } = useContext(CartContext)
    const [fetchsuccess, setFetchsuccess] = useState(false)
    const [detailRestaurant, setDetailRestaurant] = useState([])
    const [menuItem, setMenuItem] = useState([])
    const detailParams = useParams();

    useEffect(() => {
        if (fetchsuccess) {
            return
        } else {
            fetch(`${detailUrl}/${detailParams.id}`, { method: "GET" })
                .then(res => res.json())
                .then(data => {
                    setDetailRestaurant(data)
                    setFetchsuccess(true)
                })
                .catch(err => {
                    console.log(err);
                })
                fetch(`${menuUrl}/${detailParams.id}`, { method: "GET" })
                    .then(res => res.json())
                    .then(data => {
                        setMenuItem(data)
                    })
                    .catch(err => {
                        console.log(err);
                    })
        }

    }, [detailParams])

    const addToCart = (e, menu) => {
        let _cart = {...cart}
        if (!_cart.items) {
            _cart.items = {}
        }
        if (_cart.items[menu.menu_id]) {
            _cart.items[menu.menu_id] += 1;
        }
        else {
            _cart.items[menu.menu_id] = 1;
        }
        if (!_cart.totalItems) {
            _cart.totalItems = 1
        }
        else {
            _cart.totalItems += 1;
        }
        setCart(_cart)

    }

    return (
        <React.Fragment>
            {
                detailRestaurant.map((restaurant, index) => {
                    return (
                        <Container fluid key={index}>
                            <Row>
                                <Col className='top-img m-2'>
                                    <img src={restaurant.restaurant_thumb} alt={restaurant.restaurant_name} />
                                </Col>
                            </Row>
                            <Row className='m-4'>
                                <Col sm={3} md={2} lg={1} className="me-lg-3">
                                    <div className="img-round">
                                        <img src={restaurant.restaurant_thumb} alt={restaurant.restaurant_name} />
                                    </div>
                                </Col>
                                <Col xs={8}>
                                    <h1 className='pt-3 detail-title'>
                                        {restaurant.restaurant_name}
                                    </h1>
                                </Col>

                                <Col sm={1} className="m-auto">
                                    <Link to={`/placeorder`}>
                                    <Button className='float-end bg-success'>Proceed</Button>
                                    </Link>
                                </Col>

                            </Row>


                            <Row className='tabs p-3'>
                                <Tabs>
                                    <TabList>
                                        <Tab>Menu</Tab>
                                        <Tab>Overview</Tab>
                                        <Tab>Contact</Tab>
                                    </TabList>

                                    <TabPanel>
                                        {
                                            menuItem.map((menu, index) => {
                                                return (
                                                    <React.Fragment key={index}>
                                                        <div className="meal-item d-flex">
                                                            <h4 className='dark pe-2'>{menu.menu_id}.</h4>
                                                            <div className="menu-img me-3">
                                                                <img src={menu.menu_image} alt={menu.menu_name} />
                                                            </div>

                                                            <h4 className='dark'>  {menu.menu_name} - Rs.{menu.menu_price}</h4>
                                                            <Button className='addcart ps-lg-5 pe-lg-5' onClick={(e) => { addToCart(e, menu) }}>Add</Button>
                                                        </div>
                                                        <h5 className='meal-item-h5'>{menu.description}</h5>
                                                    </React.Fragment>
                                                )
                                            })
                                        }


                                    </TabPanel>
                                    <TabPanel>
                                        {
                                            detailRestaurant.map((restaurant, index) => {
                                                return (
                                                    <div className="overwiew" key={index}>
                                                        <h4 className="dark pt-3">
                                                            {restaurant.address}
                                                        </h4>
                                                        <h6 className='dark pt-3'>
                                                            Cuisine
                                                        </h6>
                                                        <p className="dark">
                                                            {restaurant.mealTypes[0].mealtype_name},
                                                            {restaurant.mealTypes[1].mealtype_name}
                                                        </p>
                                                        <h6 className="dark pt-3">
                                                            Average Cost
                                                        </h6>
                                                        <p className="dark">
                                                            ₹{restaurant.cost} for two people (approx.)
                                                        </p>
                                                    </div>
                                                )
                                            })
                                        }

                                    </TabPanel>
                                    <TabPanel>
                                        {
                                            detailRestaurant.map((restaurant, index) => {
                                                return (
                                                    <div className="contact" key={index}>
                                                        <h4 className='dark'>Phone Number</h4>
                                                        <h4 className='text-danger'>+91 {restaurant.contact_number} </h4>

                                                        <h6>{restaurant.restaurant_name}</h6>
                                                        <h4 className='gray'>
                                                            {restaurant.address}
                                                        </h4>
                                                    </div>

                                                )
                                            })
                                        }
                                    </TabPanel>
                                </Tabs>
                            </Row>
                        </Container>

                    )
                })
            }
        </React.Fragment>
    )
}

export default DetailDisplay